class ProductFixedBar extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.isTicking = false
    this.lastKnownY = window.scrollY

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)
    this.setVisibility = this.setVisibility.bind(this)

    this.setupObservers()
    this.updateEl()
  }

  setupObservers () {
    this.sectionObserver = new IntersectionObserver(this.onEntry.bind(this), {
      rootMargin: '-50% 0% -50% 0%',
    })

    this.externalEls?.section?.elements.forEach((sectionEl) => {
      this.sectionObserver.observe(sectionEl)
    })

    this.formFooterObserver = new IntersectionObserver(
      ([entry]) => this.onFormFooterIntersection(entry),
      {
        rootMargin: '0% 0% 100% 0%',
        threshold: 0,
      },
    )

    // Set up pageFooter observer
    this.pageFooterObserver = new IntersectionObserver(
      ([entry]) => this.onPageFooterIntersection(entry),
      {
        threshold: 0,
      },
    )

    if (this.externalEls?.form?.element) {
      this.formFooterObserver.observe(this.externalEls?.form?.element)
    }
    if (this.externalEls?.footer?.element) {
      this.pageFooterObserver.observe(this.externalEls?.footer?.element)
    }
  }

  setupListeners () {
    super.setupListeners()

    this.onScroll = this.onScroll.bind(this)
    this.navigationEl = this.navigationEl.bind(this)
    this.externalNavigationEl = this.externalNavigationEl.bind(this)

    this.listeners.add(window, 'scroll', this.onScroll)

    this.els?.trigger?.elements.forEach((triggerEl) => {
      this.listeners.add(triggerEl, 'click', this.navigationEl)
    })

    this.externalEls?.trigger?.elements.forEach((triggerEl) => {
      this.listeners.add(triggerEl, 'click', this.externalNavigationEl)
    })
  }

  onEntry ([entry]) {
    if (!entry.isIntersecting) return

    const sectionEl = entry.target

    this.els.trigger.elements.forEach((triggerEl) => {
      triggerEl.setAttribute(
        'aria-active',
        triggerEl.dataset.section === sectionEl.dataset.section,
      )
    })
  }

  onFormFooterIntersection (entry) {
    if (!entry.isIntersecting) {
      this.setVisibility(true)
    } else {
      this.setVisibility(false)
    }
  }

  onPageFooterIntersection (entry) {
    if (entry.isIntersecting) {
      this.setVisibility(false)
    } else {
      this.setVisibility(true)
    }
  }

  onScroll () {
    this.lastKnownY = window.scrollY
    this.requestTick()
  }

  navigationEl (event) {
    const currentEl = event.target.closest(this.els?.trigger?.selector)

    this.externalEls?.section?.elements.forEach((sectionEl) => {
      if (currentEl.dataset.section === sectionEl.dataset.section) {
        sectionEl.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }

      this.els?.trigger?.elements.forEach((tempEl) => {
        if (tempEl !== currentEl) {
          tempEl.setAttribute('aria-active', 'false')
        }
      })

      const currentState = currentEl.getAttribute('aria-active') === 'true'
      currentEl.setAttribute('aria-active', !currentState)
    })
  }

  externalNavigationEl (event) {
    const currentEl = event.target.closest(this.externalEls?.trigger?.selector)

    this.externalEls?.section?.elements.forEach((sectionEl) => {
      if (currentEl.dataset.section === sectionEl.dataset.section) {
        sectionEl.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
    })
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)
    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false
  }

  setVisibility (visible) {
    this.setAttribute('aria-hidden', !visible)
  }
}

if (!customElements.get('product-fixed-bar')) {
  customElements.define('product-fixed-bar', ProductFixedBar)
}
